"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutLinedGradientButton = OutLinedGradientButton;
exports.OutLinedDarkGradientButton = OutLinedDarkGradientButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const colors_1 = require("../../common/colors");
const theme_1 = require("../../helper/theme");
const AppText_1 = require("../AppText");
function OutLinedGradientButton({ text, disabled, onPress, }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { disabled: disabled ? disabled : false, children: (0, jsx_runtime_1.jsx)(react_native_linear_gradient_1.default, { start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, colors: colors_1.Colors.GRADIENT, style: {
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 20,
                }, children: (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onPress, style: styles.signUpButton, children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.SECONDARY_BLUE, fontWeight: 500, fontSize: 14, children: text }) }) }) }) }));
}
function OutLinedDarkGradientButton({ text, disabled, onPress, borderWidth = 1, }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { disabled: disabled ? disabled : false, children: (0, jsx_runtime_1.jsx)(react_native_1.TouchableOpacity, { onPress: onPress, style: [styles.darkButton, { borderWidth }], children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.PRIMARY_200, numberOfLines: 1, lineBreakMode: "tail", allowFontScaling: false, fontSize: (0, theme_1.normalize)(16), children: text }) }) }) }));
}
const styles = react_native_1.StyleSheet.create({
    linearGradient: {
        display: "flex",
        height: 45,
        width: 250,
        borderRadius: 20,
    },
    buttonText: {
        textAlign: "center",
        color: "#4C64FF",
        padding: 15,
        marginLeft: 1,
        marginRight: 1,
        width: 198,
    },
    signUpButton: {
        margin: 0,
        width: 300,
        borderRadius: 20,
        paddingVertical: 10,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
    },
    darkButton: {
        margin: 0,
        borderRadius: 40,
        paddingHorizontal: 16,
        height: 45,
        paddingVertical: 10,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: colors_1.Colors.DARK_700,
        color: colors_1.Colors.PRIMARY_200,
        borderColor: colors_1.Colors.DARK_500,
        borderWidth: 1,
    },
});
